// extracted by mini-css-extract-plugin
module.exports = {"dochome":"doctorprofile_dochome__2q0j8","title":"doctorprofile_title__ZZNWm","spinnerContainer":"doctorprofile_spinnerContainer__KkaV2","first":"doctorprofile_first__guBCL"};